module.exports = __webpack_public_path__ + "img/4cc67f2.svg";